// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mu-link {
  cursor: pointer;
  margin-left: 28px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/plan/new-hire/new-hire-mu-link-cell-renderer.component.scss","webpack://./../PSR%20ESP%20WebApp%20Build/src/app/pages/plan/new-hire/new-hire-mu-link-cell-renderer.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,iBAAA;ACCF","sourcesContent":[".mu-link {\n  cursor: pointer;\n  margin-left: 28px;\n}\n",".mu-link {\n  cursor: pointer;\n  margin-left: 28px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
